<template>
  <v-field :error="errors[`options.${option.name}`]" class="mb-4">
    <template v-if="option.type == 'select'">
      <select
        class="field"
        :id="option.name"
        :value="value"
        :placeholder="option.placeholder"
        @change="onInput"
      >
        <option value="">請選{{ option.label_zh }}</option>
        <option
          v-for="_option in option.options"
          :key="_option.value"
          :value="_option.value"
        >
          {{ _option.label }}
        </option>
      </select>
    </template>
    <template v-else>
      <div class="relative">
        <input
          :id="option.name"
          class="field"
          :class="{ 'pr-11': isSensitive }"
          :type="inputType"
          :value="value"
          @input="onInput"
          :placeholder="option.placeholder"
        />
        <button
          v-if="isSensitive"
          type="button"
          class="absolute inset-y-0 right-0 w-10 flex items-center justify-center text-gray-400"
          @click="revealed = !revealed"
          :aria-label="revealed ? '隱藏內容' : '顯示內容'"
        >
          <EyeOffIcon v-if="revealed" class="w-5 h-5" />
          <EyeIcon v-else class="w-5 h-5" />
        </button>
      </div>
    </template>
  </v-field>
</template>

<script>
import { EyeIcon, EyeOffIcon } from "@vue-hero-icons/outline";

export default {
  components: {
    EyeIcon,
    EyeOffIcon,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    option: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      revealed: false,
    };
  },
  computed: {
    isSensitive() {
      const text = [
        this.option.name,
        this.option.label,
        this.option.label_zh,
        this.option.placeholder,
      ]
        .filter(Boolean)
        .join(" ");

      return /password|pwd|token|code|密碼|密码|驗證|验证/i.test(text);
    },
    inputType() {
      if (!this.isSensitive) return "text";

      return this.revealed ? "text" : "password";
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
